import { Button, Card, Form, Input, Select, Space, Switch } from "antd";
import { EditOutlined } from "@ant-design/icons";
import type { FormInstance } from "antd";
import type { SelectProps } from "antd/lib/select";

type EmailSettingsPanelProps = {
  form: FormInstance;
  formData: any;
  formDisabled: boolean;
  loading: boolean;
  layout: object;
  tailLayout: object;
  emailTemplateOptions: SelectProps["options"];
  onToggleEdit: () => void;
  onEmailNotificationChange: (checked: boolean) => void;
  onValuesChange: () => void;
  onSubmit: (values: any) => void;
};

const EMAIL_TEMPLATE_FIELDS = [
  { name: "NewPolicyEmail", label: "New Policy Email Template" },
  { name: "DocumentEmail", label: "Document Email Template" },
  { name: "NonPaymentEmail", label: "Non-Payment Email Template" },
  { name: "LapseEmail", label: "Policy Lapse Email Template" },
] as const;

const EmailSettingsPanel: React.FC<EmailSettingsPanelProps> = ({
  form,
  formData,
  formDisabled,
  loading,
  layout,
  tailLayout,
  emailTemplateOptions,
  onToggleEdit,
  onEmailNotificationChange,
  onValuesChange,
  onSubmit,
}) => (
  <Card
    title="Email Settings"
    bordered
    hoverable
    extra={<EditOutlined onClick={onToggleEdit} style={{ color: "blue" }} />}
  >
    <Form
      {...layout}
      onFinish={onSubmit}
      initialValues={formData}
      disabled={formDisabled}
      form={form}
      onValuesChange={onValuesChange}
    >
      <div className="card-content">
        <Form.Item name="EmailNotification" label="Email Notification">
          <Switch
            defaultChecked={formData?.EmailNotification}
            onChange={onEmailNotificationChange}
          />
        </Form.Item>
      </div>

      {formData?.EmailNotification && (
        <>
          <Form.Item
            name="NotificationEmail"
            label="Policy holder notification email"
            extra="Used when emailing policy holders (not an internal admin inbox)."
            rules={[
              {
                type: "email",
                message: "Please enter a valid email address",
              },
            ]}
          >
            <Input
              size="large"
              type="email"
              placeholder="policyholder@example.com"
            />
          </Form.Item>

          {EMAIL_TEMPLATE_FIELDS.map((field) => (
            <div className="card-content" key={field.name}>
              <Form.Item
                name={field.name}
                label={field.label}
                rules={[{ required: true, message: `Select ${field.label}` }]}
              >
                <Select
                  allowClear
                  showSearch
                  optionFilterProp="label"
                  size="large"
                  style={{ width: "100%" }}
                  placeholder={field.label}
                  options={emailTemplateOptions}
                />
              </Form.Item>
            </div>
          ))}
        </>
      )}

      {!formDisabled && (
        <div className="card-content">
          <Form.Item {...tailLayout}>
            <Space direction="vertical" style={{ width: "100%" }}>
              <Button
                style={{ marginBottom: 10 }}
                block
                size="large"
                htmlType="submit"
                loading={loading}
              >
                Submit
              </Button>
            </Space>
          </Form.Item>
        </div>
      )}
    </Form>
  </Card>
);

export default EmailSettingsPanel;
